<script setup lang="ts">
// Define custom CMS element interface matching backend config structure
interface CmsElementLandingpageSidebarNavigation {
    id: string
    type: 'landingpage-sidebar-navigation' | 'landingpage_sidebar_navigation'
    slot: string
    versionId?: string
    config: {
        title?: { value?: string, source?: string }
        links?: {
            value?: Array<{
                linkText: { value?: string, source?: string }
                linkUrl: { value?: string, source?: string }
            }>,
            source?: string
        }
    }
}

const props = defineProps<{
    content: CmsElementLandingpageSidebarNavigation
}>()

// Extract title from config
const title = computed(() => {
    return props.content?.config?.title?.value as string || ''
})

// Extract and process links array from config
const links = computed(() => {
    const linksConfig = props.content?.config?.links?.value
    if (!Array.isArray(linksConfig)) return []

    return linksConfig.map(link => ({
        text: link.linkText?.value as string || '',
        url: link.linkUrl?.value as string || ''
    })).filter(link => link.text && link.url) // Filter out invalid links
})
</script>

<template>
    <ComponentAccordion
        :items="[{ id: 'navigation', headline: title }]"
        headline-tag="h2"
        headline-tag-class="text-xl font-bold"
        :no-accordion-on-desktop="true"
        :show-headline-on-desktop="false"
        type="single"
        :has-border="true"
    >
        <template #navigation>
            <!-- Desktop: Show title with same H2 styling as mobile accordion header -->
            <div class="hidden lg:block mb-4">
                <h2 class="text-xl font-bold">
                    {{ title }}
                </h2>
            </div>

            <!-- Navigation links -->
            <nav>
                <ul class="space-y-2 pb-4 lg:pb-0">
                    <li
                        v-for="(link, index) in links"
                        :key="index"
                    >
                        <NuxtLink
                            :to="link.url"
                            class="block py-2 hover:text-primary transition-colors"
                        >
                            {{ link.text }}
                        </NuxtLink>
                    </li>
                </ul>
            </nav>
        </template>
    </ComponentAccordion>
</template>